import React, { useState } from 'react';
import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const ResearchCard = ({ title, category, image ,link}) => (
  <div className="group relative overflow-hidden rounded-lg h-96 cursor-pointer">
    {/* Image with zoom on hover */}

    <div className="absolute inset-0 transition-transform duration-500 ease-in-out transform group-hover:scale-110">
      <img src={image} alt={title} className="w-full h-full object-cover" />
    </div>

    {/* Dark overlay on hover */}
    <div
      className="absolute inset-0 transition-opacity duration-500 opacity-0 group-hover:opacity-80"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.8)' }}
    ></div>

    {/* Default text overlay (visible when not hovering) */}
    <div className="absolute inset-0 p-6 flex flex-col justify-between transition-opacity duration-500 opacity-100 group-hover:opacity-0">
      <div>
        <h3 className="text-2xl font-bold" style={{ color: '#FFFFFF' }}>
          {title}
        </h3>
      </div>
    </div>

    {/* Detailed overlay (visible on hover) */}
    <div className="absolute inset-0 p-6 flex flex-col justify-between transition-opacity duration-500 opacity-0 group-hover:opacity-100 transform translate-y-4 group-hover:translate-y-0">
      <div>
       
        <h3 className="text-2xl font-bold mb-4" style={{ color: '#FFFFFF' }}>
          {title}
        </h3>
        <p className="text-sm text-left" style={{ color: '#FFFFFF' }}>
         {category}
        </p>
      </div>
      <div className="flex justify-end">
        <Link to={link} ><ArrowUpRight style={{ color: '#FFFFFF', width: '24px', height: '24px' }} /></Link>
      </div>
    </div>
  </div>
);

const HomeWhatWeAre = () => {
  const [activeTab, setActiveTab] = useState('enterprise');

  const tabs = [
    { id: 'enterprise', label: 'Enterprise Technologies' },
    { id: 'services', label: 'Services' },
    { id: 'products', label: 'Products' }
  ];

  const cards = {
    enterprise: [
      {
        link:"services/infor",
        category: "Our Team of Professional Infor Consultants Takes A Tailored Approach To Meet Your Specific Needs.",
        title: "Infor Expert Consultation",
        image: "https://ik.imagekit.io/kqumni8l2/HomePage/Services&Products%20/infor%209.jpg?updatedAt=1740036017593"
      },
      {
        link:"services/sap",
        category: "Our SAP Team Empowers Organizations To Optimize Their SAP Software Utilization, Managing Business Operations.",
        title: "SAP Staffing Services",
        image: "https://ik.imagekit.io/kqumni8l2/services_logo/SAP%20Services%20Banner%20KCS.jpg?updatedAt=1744352350962"
      },
      // {
      //   link:"services/oracle_and_id_edwards",
      //   category: "Our Oracle Services Expertise Business Excellence with Support Mergers, Upgrades and Legacy Systems to Ensure Seamless Adoption.",
      //   title: "Oracle NetSuite ERP",
      //   image: "https://ik.imagekit.io/kqumni8l2/services_logo/Oracle%20KCS.jpg?updatedAt=1744352350460"
      // },
      
      // {
      //   link:"services/microsoft",
      //   category: "Our Microsoft Expert Consultants Provide Comprehensive Services from Implementation and Customization to Ongoing Support, Addressing All Your Dynamics Needs.",
      //   title: "Microsoft Dynamics Services",
      //   image: "https://ik.imagekit.io/kqumni8l2/services_logo/Microsoft.png?updatedAt=1744603966443"
      // },
      {
          link:"/services/odoo",
        category: "We are Committed To Providing Ongoing Odoo ERP Implementation & Support Services to Ensure Your Business Operates Smoothly And Efficiently",
        title: "Odoo Software Implementation & Consultation",
        image: "https://ik.imagekit.io/kqumni8l2/services_logo/Odoo%20kcs.jpg?updatedAt=1744352350611"
      },
      {
        link:"/services/aws",
        category: "We Offer Cloud-Native Development, Data Migration, Analytics and Cloud Management Services for Organizations to Achieve Success Digital Transformation for AWS Journey.",
        title: "AWS Cloud Service Provider",
        image: "https://ik.imagekit.io/kqumni8l2/services_logo/AWS%20kcs%202.jpg?updatedAt=1744352350279"
      },
      {
        link:"/services/googlecloud",
        category: "Kapil Tech is Ready to Fast-Track Your Transition to Google Cloud with Leverage Cutting-Edge Data Services and Sustainable Digital Infrastructure Using AI.",
        title: "Google Cloud Solutions",
        image: "https://ik.imagekit.io/kqumni8l2/services_logo/Google%20cloud%20kcs%202.jpg?updatedAt=1744352351555"
      }
    ],
    services: [
      {
         link:"/services/development",
        category: "Our Team is Equipped to Tackle Any Challenge. Whether it Involves Extending Software Capabilities, Developing Tailored Reports, or Implementing Technical Integrations.",
        title: "Applicaiton Development ",
        image: "https://ik.imagekit.io/kqumni8l2/HomePage/Services&Products%20/application-development.jpg?updatedAt=1740032887163"
      },
      {
        link:"/services/supply_chain_management",
        category: "Our Expertise Consulting & IT Services are Designed to Address Various Aspects Of Supply Chain Management Ensuring Your Operations Run Smoothly and Efficiently.",
        title: "Supply Chain Management",
        image: "https://ik.imagekit.io/kqumni8l2/HomePage/Services&Products%20/SCM.jpg?updatedAt=1740032887169"
      },
      {
        link:"/services/manufacturing_execution_systems",
        category: "Achieve Manufacturing Excellence with KCS Tech. Our Comprehensive MES Solutions Address Your Enterprise-Wide Challenges in Manufacturing Operations Today!",
        title: "Manufacturing Execution System",
        image: "https://ik.imagekit.io/kqumni8l2/HomePage/Services&Products%20/MES.jpg?updatedAt=1740032886405"
      },
      {
         link:"/services/testing",
        category: "Our Industry-Leading Solutions Encompass Enterprise Systems Testing and Test Consulting with Top Technology Providers. Transform Your Quality Journey to Enhance Resilience in Your Business through  Expertise Testing Solutions.",
        title: "Testing",
        image: "https://ik.imagekit.io/kqumni8l2/HomePage/Services&Products%20/Testing.jpg?updatedAt=1740032886400"
      },
      {
        link:"/services/product_lifecycle_management",
        category: "Streamline Product Development and Drive Innovation with KCS Tech's Product Lifecycle Management (PLM) Ensuring Your Products Meet Market Needs with Holistic Approach.",
        title: "Product Lifecycle Management",
        image: "https://ik.imagekit.io/kqumni8l2/HomePage/Services&Products%20/Product%20Lifecycle%20Management.jpg?updatedAt=1740032886497"
      },
      {
        link:"/services/customer_relationship_management",
        category: "KCS Tech’s CRM Practice Leverages Extensive Industry Experience to Deliver Best-in-Class Implementation & Support Services to Recognize and Utilize The Capabilities of Various CRM Solutions.",
        title: "Customer Relationship Management",
        image: "https://ik.imagekit.io/kqumni8l2/HomePage/Services&Products%20/CRM.jpg?updatedAt=1740032886485"
      }
    ],
    products: [
      // {
      //   link:"/services/ifca",
      //   category: "Is Your Business Ready for E-Invoicing? KCS Tech Empowers Companies With Next-Generation Cloud Solutions Through IFCA Software that Enhance Business Operations and Prepare You for The Future of Work.",
      //   title: "IFCA",
      //   image: "https://ik.imagekit.io/kqumni8l2/HomePage/Services&Products%20/IFCA.jpg?updatedAt=1740481602228"
      // },
      // {
      //    link:"/services/mpdv",
      //   category: "Unlock The Full Potential of Your Data with KCS Tech's Innovative Solutions. Our MES HYDRA, Advanced Planning and Scheduling System (APS) Optimize Production Processes Transform Your Data into Valuable Profits.",
      //   title: "MPDV",
      //   image: "https://ik.imagekit.io/kqumni8l2/HomePage/Services&Products%20/MPDV.jpg?updatedAt=1740481602224"
      // },
      {
         link:"/services/mobillor",
        category: "Mobillor Empower The Manufacturing Industry By Facilitating A Comprehensive Industry 4.0 Journey. Kapil Tech Mobillor's Suite of Solutions Support Digital Transformation of Businesses to Enhance Seamless Integration with Advanced Technologies.",
        title: "Mobillor ",
        image: "https://ik.imagekit.io/kqumni8l2/HomePage/Services&Products%20/Mobillor.jpg?updatedAt=1740481602018"
      },
      // {
      //    link:"/services/qrra",
      //   category: "QRRA from KCS Tech Offers End-to-End Retail Automation Solutions to Global Retailers, Distributors and Manufacturers. We Help Solve Your Biggest Retail Challenges with Cloud-Based Solutions. Partner with Us to Transform Your Retail Operations",
      //   title: "QRRA",
      //   image: "https://ik.imagekit.io/kqumni8l2/HomePage/Services&Products%20/QR%20Retail.jpg?updatedAt=1740481602067"
      // },
      // {
      //    link:"/services/hexabuilt",
      //   category: "HexaBuild is An Integrated Construction Management Software That Helps Companies Solve Challenges Through End-to-End Digitization. Our Suite Solutions Streamline Your Operations, Now Partner With Us To Bring Profitability To Your Construction Business.",
      //   title: "Hexabuild",
      //   image: "https://ik.imagekit.io/kqumni8l2/HomePage/Services&Products%20/HEXA%20BUILD.jpg?updatedAt=1740481601949"
      // },
      {
         link:"/services/finsta",
        category: "KCS Tech Offers Integrated Financial Management Systems (IFMS) with Finsta, Providing Tailored Fintech Solutions that Enhance Customer Satisfaction and Drive Business Growth. Partner with Us for Streamlined Fintech Solutions.",
        title: "Finsta",
        image: "https://ik.imagekit.io/kqumni8l2/HomePage/Services&Products%20/FINSTA.jpg?updatedAt=1740481601948"
      }
    ]
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      {/* Section Header */}
      <div className="text-center mb-8">
  <h2 className="text-3xl font-bold" style={{ color: '#4F46E5' }}>
   Our Comprehensive IT Services and Technologies 
  </h2>
  <p className="mt-4 text-md text-center max-w-2xl mx-auto" style={{ color: '#4B5563' }}>
    Check Out Our Services and Solutions: We Offer Tools to Boost Your Business with Enterprise Technologies and Advanced Software Products.
  </p>
</div>

      {/* Tabs */}
      <div className="grid grid-cols-3 mb-8 gap-4">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className="px-6 py-4 text-left transition-all duration-200"
            style={{
              backgroundColor: activeTab === tab.id ? '#4F46E5' : '#F3F4F6',
              color: activeTab === tab.id ? '#FFFFFF' : '#4B5563',
              boxShadow: activeTab === tab.id ? '0px 4px 6px rgba(0, 0, 0, 0.1)' : 'none',
              transform: activeTab === tab.id ? 'translateY(-2px)' : 'none'
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {cards[activeTab].map((card, index) => (
          <ResearchCard key={index} {...card} />
        ))}
      </div>
    </div>
  );
};

export default HomeWhatWeAre;
